// extracted by mini-css-extract-plugin
module.exports = {"container":"error-box_container__aQC9e","content":"error-box_content__Vlwxd","icon":"error-box_icon__2h2aA","linkSection":"error-box_linkSection__jY4Mg"};